import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 dark:bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Map */}
          <div>
            <h3 className="text-lg font-bold mb-4">Konum</h3>
            <div className="rounded-lg overflow-hidden border-2 border-gray-700">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.3626739844773!2d28.99!3d41.06!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDAzJzM2LjAiTiAyOMKwNTknMjQuMCJF!5e0!3m2!1str!2str!4v1234567890"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Reaksiyon Araştırma Location"
              ></iframe>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#F05627] transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#F05627] transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#F05627] transition-colors">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#F05627] transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('nav.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-[#F05627] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-400">
                  {t('contact.info.addressText')}
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-[#F05627] flex-shrink-0" />
                <a
                  href="mailto:info@reaksiyonarastirma.com"
                  className="text-sm text-gray-400 hover:text-[#F05627] transition-colors"
                >
                  info@reaksiyonarastirma.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © 2025 Reaksiyon Araştırma. {t('footer.rights')}
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/privacy" className="text-gray-500 hover:text-[#F05627] transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="/terms" className="text-gray-500 hover:text-[#F05627] transition-colors">
                {t('footer.terms')}
              </Link>
              <Link to="/cookie" className="text-gray-500 hover:text-[#F05627] transition-colors">
                {t('footer.cookie')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;